import React, { useEffect, useState } from 'react'
import { code2region } from './Utils'

export default function FireReg(props) {
	
	const { ENV, DS, region } = props
	
	const [total, setTotal] = useState([0,0,0,0,0,0,0,0,0])
	
	const shortType = {
		'Теплоэлектроцентраль (ТЭЦ)': 'ТЭЦ',
		'Электростанция (ЭС)': 'ЭС',
		'Электростанция газотурбинная (ГТЭС)': 'ГТЭС',
		'Электростанция дизельная (ДЭС)': 'ДЭС',
		'Тепловая электростанция (ТЭС)': 'ТЭС',
		'Электростанция тепловая конденсационная (КЭС)': 'КЭС',
		'Атомная электростанция (АЭС)': 'АЭС',
		'Подстанция (ПС)': 'ПС',
		'Линия электропередачи (ЛЭП)': 'ЛЭП',
		//'Магистральный нефтепровод': 'МНП',
		'Магистральный продуктопровод': 'МПП',
		'Компрессорная станция (КС), компрессорный цех (КЦ)': 'КС/КЦ',
		'Промежуточная (дожимная) перекачивающая станция (ППС)': 'ППС',
		'Магистральный газопровод': 'МГП',
		'Газопровод промысловый (газопровод подключения)': 'ГПП',
		'Газопровод распределительный высокого давления': 'ГРВД',
		'Газораспределительная станция (ГРС)': 'ГРС',
		'Автомобильная газозаправочная станция': 'АГЗС',
		'Конденсато-продукто-этанолопровод': 'КПЭП',
		'Тяговая подстанция (железной дороги)': 'ПС (ЖД)',
		'Станция подземного хранения газа (СПХГ)': 'СПХГ',
		'Нефтебаза (склад нефти или нефтепродуктов)': 'НБ',
		'Переключательный пункт': 'ПП',
		'Газовый промысел': '-IGNORE-',
		'Электростанция солнечная (СЭС)': 'СЭС',
		
		'Электростанция': 'ЭС',
		'Подстанция': 'ПС',
		'ЛЭП': 'ЛЭП',
		'Магистральный нефтепровод': 'МН',
		'Продуктопроводы и прочие нефтепроводы': 'ПП',
		'Объекты хранения углеводородов': 'НБ/ГХ',
		'Магистральный газопровод': 'МГ',
		'Газопровод промысловой': 'ГПП',
		'ГРС и ПС': 'ГРС/ПС',
	}

	const longType = {
		'Теплоэлектроцентраль (ТЭЦ)': 'Теплоэлектроцентраль',
		'Электростанция (ЭС)': 'Электростанция',
		'Электростанция газотурбинная (ГТЭС)': 'Электростанция газотурбинная',
		'Электростанция дизельная (ДЭС)': 'Электростанция дизельная',
		'Тепловая электростанция (ТЭС)': 'Тепловая электростанция',
		'Электростанция тепловая конденсационная (КЭС)': 'Электростанция тепловая конденсационная',
		'Атомная электростанция (АЭС)': 'Атомная электростанция',
		'Подстанция (ПС)': 'Подстанция',
		'Линия электропередачи (ЛЭП)': 'Линия электропередачи',
		//'Магистральный нефтепровод': 'Магистральный нефтепровод',
		'Магистральный продуктопровод': 'Магистральный продуктопровод',
		'Компрессорная станция (КС), компрессорный цех (КЦ)': 'Компрессорная станция, компрессорный цех',
		'Промежуточная (дожимная) перекачивающая станция (ППС)': 'Промежуточная перекачивающая станция',
		'Магистральный газопровод': 'Магистральный газопровод',
		'Газопровод промысловый (газопровод подключения)': 'Газопровод промысловый (газопровод подключения)',
		'Газопровод распределительный высокого давления': 'Газопровод распределительный высокого давления',
		'Газораспределительная станция (ГРС)': 'Газораспределительная станция',
		'Автомобильная газозаправочная станция': 'Автомобильная газозаправочная станция',
		'Конденсато-продукто-этанолопровод': 'Конденсато-продукто-этанолопровод',
		'Тяговая подстанция (железной дороги)': 'Тяговая подстанция (железной дороги)',
		'Станция подземного хранения газа (СПХГ)': 'Станция подземного хранения газа (СПХГ)',
		'Нефтебаза (склад нефти или нефтепродуктов)': 'Нефтебаза (склад нефти или нефтепродуктов)',
		'Переключательный пункт': 'Переключательный пункт',
		'Газовый промысел': '-IGNORE-',
		'Электростанция солнечная (СЭС)': 'Электростанция солнечная',
		
		'Электростанция': 'Электростанция',
		'Подстанция': 'Подстанция',
		'ЛЭП': 'Линия электропередачи',
		'Магистральный нефтепровод': 'Магистральный нефтепровод',
		'Продуктопроводы и прочие нефтепроводы': 'Продуктопроводы и прочие нефтепроводы',
		'Объекты хранения углеводородов': 'Объекты хранения углеводородовГХ',
		'Магистральный газопровод': 'Магистральный газопровод',
		'Газопровод промысловой': 'Газопровод промысловой',
		'ГРС и ПС': 'Газораспределительная или Перекачивающая станция',
	}
	
	const typeGroups = [
		[
			'Теплоэлектроцентраль (ТЭЦ)',
			'Электростанция газотурбинная (ГТЭС)',
			'Электростанция дизельная (ДЭС)',
			'Тепловая электростанция (ТЭС)',
			'Электростанция тепловая конденсационная (КЭС)',
			'Атомная электростанция (АЭС)',
			'Электростанция солнечная (СЭС)',
			'Электростанция',
		], [
			'Подстанция (ПС)',
			'Автомобильная газозаправочная станция',
			'Тяговая подстанция (железной дороги)',
			'Переключательный пункт',
			'Подстанция',
		], [
			'Линия электропередачи (ЛЭП)',
			'ЛЭП',
		], [
			'Магистральный нефтепровод',
		], [
			'Магистральный продуктопровод',
			'Конденсато-продукто-этанолопровод',
			'Продуктопроводы и прочие нефтепроводы',
		], [
			'Компрессорная станция (КС), компрессорный цех (КЦ)',
			'Промежуточная (дожимная) перекачивающая станция (ППС)',
			'Станция подземного хранения газа (СПХГ)',
			'Нефтебаза (склад нефти или нефтепродуктов)',
			'Объекты хранения углеводородов',
		], [
			'Магистральный газопровод',
		], [
			'Газопровод промысловый (газопровод подключения)',
			'Газопровод распределительный высокого давления',
			'Газопровод промысловой',
		], [
			'Газораспределительная станция (ГРС)',
			'ГРС и ПС',
		]
	]
	
	useEffect(() => {
		const types = {}
		const _total = []
		DS.data.fireRegCl[region].forEach(e => {
			if (shortType[e.type] !== '-IGNORE-') {
				if (types[e.type] === undefined) types[e.type] = 0
				types[e.type]++
			}
		})
		typeGroups.forEach((g, i) => {
			_total[i] = 0
			g.forEach(e => {
				_total[i] = _total[i] + (types[e] ?? 0)
			})
		})
		setTotal(_total)
	}, [DS.data.fireRegCl[region]])
	
	
	return <div className="col fire-reg p-3">
		<div className="font-bold text-lg text-300">{code2region[region].name}</div>
		<div className="mt-2"><p className="title">{'Объекты ТЭК в зоне возможного распространения пожара (2,5км)'}</p></div>
		<div className="flex table-total mt-3 mx-3">
			<div className="col-2 pr-0">
				<div className="text-red text-center h1 m-0">{DS.data.fireRegCl[region].length}</div>
			</div>
			<div className="col pr-0 ml-4">
				<div className="row border-bottom flex">
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">Электростанция</div><div className="col-2 h4">{total[0]}</div>
					</div></div>
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">Магистральный нефтепровод</div><div className="col-2 h4">{total[3]}</div>
					</div></div>
					<div className="col"><div className="row flex">
						<div className="col ml-3">Магистральный газопровод</div><div className="col-2 h4">{total[6]}</div>
					</div></div>
				</div>
				<div className="row border-bottom flex">
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">Подстанция</div><div className="col-2 h4">{total[1]}</div>
					</div></div>
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">Нефтепродукто-провод</div><div className="col-2 h4">{total[4]}</div>
					</div></div>
					<div className="col"><div className="row flex">
						<div className="col ml-3">Газопровод промысловой</div><div className="col-2 h4">{total[7]}</div>
					</div></div>
				</div>
				<div className="row flex">
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">ЛЭП</div><div className="col-2 h4">{total[2]}</div>
					</div></div>
					<div className="col"><div className="row border-right flex">
						<div className="col ml-3">Объекты хранения углеводородов</div><div className="col-2 h4">{total[5]}</div>
					</div></div>
					<div className="col"><div className="row flex">
						<div className="col ml-3">ГРС</div><div className="col-2 h4">{total[8]}</div>
					</div></div>
				</div>
			</div>
		</div>
		
		<div className="row border-top mt-0"></div>
		<div className="mt-3"><p className="title">{'Объекты:'}</p></div>
		<div className="row border-bottom font-bold mt-2 mb-0 pb-2 op5 flex">
			<div className="col-2 pl-5">Расстояние</div>
			<div className="col-1">Тип</div>
			<div className="col">Наименование</div>
			<div className="col-3">Организация</div>
		</div>
		<div className="scrollable">
			{DS.data.fireRegCl[region].map((e, i) => <div key={i} className="row border-bottom py-2 flex">
				<div className="col-2 pl-5">{e.dist}</div>
				<div className="col-1" data-toggle="tooltip" data-placement="right" title={longType[e.type]}>{shortType[e.type]}</div>
				<div className="col">{e.name}</div>
				<div className="col-3">{e.head}</div>
			</div>)}
		</div>
	</div>
	
}

